import * as React from 'react';
const SvgThreeJs = (props) => (
  <svg viewBox="0 0 81 85" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      clipRule="evenodd"
      d="M20.707 84 1 1l79 23.663L20.707 84Z"
      stroke="#000"
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="m40.485 12.834 9.847 41.512-39.478-11.835 29.631-29.677Z"
      stroke="#000"
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="M30.69 48.141 25.8 27.52l19.613 5.858L30.69 48.14ZM20.907 6.923l4.89 20.621-19.613-5.857L20.907 6.923ZM60.132 18.678l4.89 20.622-19.613-5.858 14.723-14.764ZM30.692 48.155l4.89 20.622L15.97 62.92l14.723-14.765Z"
      stroke="#000"
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgThreeJs;
